import {postMethod, getMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/ai/threads/runs', request)
}

async function get(request) {
    return await getMethod('/proxy/ai/threads/runs', request)
}

export {post, get}
